export const WSW_DOMAIN_SUFFIX = ".workspaces-web.com";
export const WSW_FIPS_DOMAIN_SUFFIX = ".workspaces-web-fips.com";

// https://regex101.com/r/Swyc9X/2
export enum UrlParameter {
    APPS = "applications",
    LEGACY = "legacy",
    DEEPLINK = "deeplink",
    DEEP_LINKS = "deepLinks",
    MOBILE_DEVICE = "mobileDevice",
}

export const URL_REG_EX =
    "^$|^(https?:\\/\\/)?(?:www\\.|(?!www))[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$|^(http?s{0,1}:\\/\\/)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\\/.*)?$";
